import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performGetRequest, performPostRequest } from '@atlassian/jira-fetch';
import type { IncidentsCopyStatusResponse } from '../../../../common/types';

const getIncidentsCopyStatus = (cloudId: string) => {
	const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/status`;

	return performGetRequest<IncidentsCopyStatusResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getIncidentCopyStatusEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

const copyIncidents = (cloudId: string) => {
	const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/start`;

	return performPostRequest(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'copyIncidentsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

export { getIncidentsCopyStatus, copyIncidents };
